import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { FarmService } from 'src/app/services/farm-service.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
  selector: 'smart-manage-thing',
  templateUrl: './manage-thing.component.html',
  styleUrls: ['./manage-thing.component.scss', '../platform-color/platform-color.css']
})
export class ManageThingComponent implements OnInit, OnDestroy {

  farmId: any = [];
  plotId: string;
  thingsByid: any = [];
  loading: boolean = false;

  constructor(private farmService: FarmService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,) {
    this.route.params.subscribe(routeParams => {
      window.scroll(0, 0);
      this.farmId = routeParams["farm"];
      this.plotId = routeParams["plot"];

    });
    sessionStorage.setItem("farmmenu", this.farmId);
    sessionStorage.setItem("plotmenu", this.plotId);
    // this.getThingsById();
  }

  ngOnInit(): void {
    // this.dtOptions = {};
  }

  ngOnDestroy() {
    $('#setDevice').modal('hide');
  }

  // getThingsById() {
  //   this.spinner.show();
  //   setTimeout(async () => {
  //     this.farmService.getThingMenuById(this.farmId, this.plotId).subscribe(async success => {
  //       if (success.code == 200) {
  //         this.thingsByid = success.data.data;
  //         this.loading = true;
  //       }
  //     });
  //     this.spinner.hide();
  //   }, 100);
  // }


  // public async deleteDomain(data) {
  //   await this.posSer.DeletePosMachine(data)
  // }

  // public async recoverDomain(data) {
  //   await this.posSer.recoverDomain(data)
  // }

  // public async delete(Pos_code: any) {
  //   let data = {
  //     Pos_code: Pos_code,
  //     Comp_code: sessionStorage.getItem("Comp_code")
  //   }
  //   console.log("data->", data)
  //   this.spinner.show();
  //   setTimeout(async () => {
  //     Swal.fire({
  //       title: 'Delete Domain',
  //       text: "ต้องการลบหรือไม่ ?",
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'Confirm'
  //     }).then((result) => {
  //       if (result.value) {
  //         this.deleteDomain(data);
  //         Swal.fire(
  //           'Deleted!',
  //           'Domain has been deleted.',
  //           'success'
  //         )
  //       }
  //     })
  //     this.spinner.hide();
  //     // location.reload();
  //   }, 100);
  // }

  // public async recover(Dom_Id: any) {
  //   let data = {
  //     Dom_Id: Dom_Id
  //   }
  //   this.spinner.show();
  //   setTimeout(async () => {
  //     Swal.fire({
  //       title: 'Recover Base UOM',
  //       text: "ต้องการนำกลับมาหรือไม่ ?",
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'Confirm'
  //     }).then((result) => {
  //       if (result.value) {
  //         this.recoverDomain(data);
  //         Swal.fire(
  //           'Recover Complete!',
  //           'Base UOM has been recovered.',
  //           'success'
  //         )
  //       }
  //     })
  //     this.spinner.hide();

  //   }, 100);
  //   // location.reload();
  // }
}
